import { Outlet, To } from 'react-router-dom'

import { DocumentsDataTableQuery } from 'generated/resources/datatable.graphql'

import { useDataTable } from 'modules/core/components/DataTable'

import { Folder } from 'modules/documents/hooks/useGetFolders'
import type Employee from 'modules/employees/store/models/Employee'

type Props = {
  parentRoute?: To
  folder?: Folder | null
  initialFolder?: Folder | null
  employee?: Employee
  space?: string
}

const ContextFromPage = ({ parentRoute, folder, initialFolder, employee, space }: Props) => {
  const dataTable = useDataTable<DocumentsDataTableQuery>()
  const documentsEntity = dataTable.data

  const contextValue = {
    documentsEntity,
    folder: folder,
    initialFolder: initialFolder,
    employee,
    parentRoute,
    space,
  }

  return <Outlet context={contextValue} />
}

export default ContextFromPage
